// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___5vqh","left":"styles_left__3wfus"};